"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocketIOConnection = void 0;
const wolfy87_eventemitter_1 = __importDefault(require("wolfy87-eventemitter"));
const socket_io_client_1 = __importDefault(require("socket.io-client"));
const events_1 = require("./events");
const utils_1 = require("@sqvr/utils");
class SocketConnection extends wolfy87_eventemitter_1.default {
  constructor() {
    super(...arguments);
    this._isIntialized = false;
    this.socketEventsQueue = [];
    this.connected = false;
    this.onDisconnect = reason => {
      if (reason === 'io server disconnect') {
        this._instance.connect();
      }
    };
    this.onConnect = () => {
      this.connected = true;
      this._instance.emit('authenticate', this._apiKey);
      if (!this._isIntialized) {
        events_1.EVENTS.map(event => {
          this._instance.on(event, data => {
            this.emit(event, data);
          });
        });
        this._isIntialized = true;
      }
      this.socketEventsQueue.forEach(({
        event,
        data
      }) => {
        this.sendMessage(event, data);
      });
      this.socketEventsQueue = [];
    };
    this.onConnectionError = () => {
      this.emit(events_1.WSEvents.ConnectionError);
    };
    this.onConnectionLost = () => {
      this.emit(events_1.WSEvents.ConnectionLost);
    };
    this.sendMessage = (event, ...data) => {
      if (!this.connected) {
        this.socketEventsQueue.push({
          event,
          data
        });
        return;
      }
      this._instance.emit(event, ...data);
    };
  }
  connect(url, apiKey, userId) {
    this._url = url;
    this._apiKey = apiKey;
    this._userId = userId;
    this._instance = (0, socket_io_client_1.default)(url, {
      transportOptions: {
        polling: {
          extraHeaders: {
            'X-Local-time': (0, utils_1.formatDate)(new Date(), {
              customFormat: 'yyyy-MM-dd HH:mm:ss'
            })
          }
        }
      }
    });
    this._instance.on('connect', this.onConnect);
    this._instance.on('disconnect', this.onDisconnect);
    this._instance.on('connect_error', this.onConnectionError);
    this._instance.on('connect_failed', this.onConnectionLost);
  }
}
exports.SocketIOConnection = new SocketConnection();